import { render } from "./BooksSection.vue?vue&type=template&id=4ac6ef40"
import script from "./BooksSection.vue?vue&type=script&lang=js"
export * from "./BooksSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__